import { InternalUserListPaginatedResponseDtoWithInvitationCount, InternalUserListResponseDto } from '@/lib/interfaces/internal/users';
import { Paginated, Pagination } from '@/lib/interfaces/utils';
import { Dispatch, SetStateAction, useCallback, useEffect, useState } from 'react';
import useApiRequest from '../../../lib/hooks/useRequest';
import DataFetchParent from '../../../ui/components/ui/data-fetch';
import { UserDataTable } from './user-data-table';

const InternalUserFetchParent = ({
  setInvitationCount,
  searchQuery
}: {
  setInvitationCount: Dispatch<SetStateAction<number>>;
  searchQuery: string;
}) => {
  return (
    <>
      <InternalUserFetch setInvitationCount={setInvitationCount} searchQuery={searchQuery} />
    </>
  );
};

const InternalUserFetch = ({ setInvitationCount, searchQuery }: { setInvitationCount: Dispatch<SetStateAction<number>>; searchQuery: string }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [initLoading, setInitLoading] = useState(true);
  const [customers, setCustomers] = useState<InternalUserListResponseDto[]>();
  const [reload, setReload] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [pagination, setPagination] = useState<Pagination>({
    pageIndex: searchQuery.split('page=')[1] ? parseInt(searchQuery.split('page=')[1].split('&')[0]) - 1 : 0,
    pageSize: 10
  });

  const { apiRequest } = useApiRequest();

  const getCustomersInit = useCallback(async () => {
    let url = `users/internal/initial?limit=${pagination.pageSize}`;
    if (searchQuery) {
      url += `&${searchQuery}`;
    }
    setInitLoading(true);
    const res = await apiRequest<InternalUserListPaginatedResponseDtoWithInvitationCount>(url, 'GET');

    setInitLoading(false);
    if (res.data) {
      setCustomers(res.data.users.docs);
      setPageCount(Math.ceil(res.data.users.count / pagination.pageSize));
      setPageCount(res.data.users.pageCount);
      setInvitationCount(res.data.invitationCount);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiRequest, pagination.pageSize, setInvitationCount]);

  const getCustomersPaginated = useCallback(async () => {
    let url = `users/internal?limit=${pagination.pageSize}`;
    if (searchQuery) {
      url += `&${searchQuery}`;
    }

    const pageIndex = searchQuery.split('page=')[1] ? parseInt(searchQuery.split('page=')[1].split('&')[0]) - 1 : 0;
    if (pageIndex !== pagination.pageIndex) {
      setPagination({
        ...pagination,
        pageIndex: pageIndex
      });
    }
    setIsLoading(true);
    const res = await apiRequest<Paginated<InternalUserListResponseDto>>(url, 'GET');

    setIsLoading(false);
    if (res.data) {
      setCustomers(res.data.docs);
      setPageCount(Math.ceil(res.data.count / pagination.pageSize));
      setPageCount(res.data.pageCount);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiRequest, pagination.pageSize, searchQuery]);

  useEffect(() => {
    getCustomersInit();
  }, [getCustomersInit, reload]);

  useEffect(() => {
    if (!initLoading) {
      getCustomersPaginated();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getCustomersPaginated, searchQuery]);

  return (
    <>
      <DataFetchParent
        isLoading={initLoading}
        data={customers}
        renderElement={() => (
          <UserDataTable
            data={customers ?? []}
            setReload={setReload}
            setPagination={setPagination}
            pageCount={pageCount}
            pagination={pagination}
            isLoading={isLoading}
          />
        )}
      />
    </>
  );
};

export default InternalUserFetchParent;
